import { useState, useCallback } from 'react';
import { SelectedAddOn } from '@acorn-portal/shared/src/services/renewalsApi';
import { ICreateNewRenewalVersionResponse, updateCheckout } from '@acorn-portal/shared/src/store/renewal.slice';
import { IPaymentOptionsValues } from '@acorn-portal/shared/src/pages/renewal/PaymentOptions';
import { useAppDispatch, useAppSelector } from './reduxHook';
import useToast from './useToast';
import useRateRenewal from '@acorn-portal/shared/src/hooks/useRateRenewal';

const useUpdateAddons = (renewal: ICreateNewRenewalVersionResponse) => {
	const [isAddOnLoading, setLoading] = useState(false);
	const policy = useAppSelector((redux) => redux.fullPolicy);

	const { rateRenewal } = useRateRenewal();
	const popToast = useToast();
	const dispatch = useAppDispatch();
	const onUpdateAddons = useCallback(
		async (selectedAddons: SelectedAddOn[]) => {
			setLoading(true);
			try {
				await rateRenewal({
					renewalState: { ...renewal, addons: selectedAddons },
					fullPolicy: policy,
					updateAddons: true,
					redirectToSummary: false,
				});
				const updateCheckoutAmount: IPaymentOptionsValues = {
					method: renewal.paymentOptions.method,
					deposit: renewal.paymentOptions.deposit,
				};
				dispatch(updateCheckout(updateCheckoutAmount));
				setLoading(false);
			} catch (e) {
				console.error(e);
				popToast('Unable to process quote with add-on. Please try again.');
			} finally {
				setLoading(false);
			}
		},

		[renewal],
	);
	return { onUpdateAddons, isAddOnLoading };
};

export default useUpdateAddons;
